import { Feature } from '../../types/service';

export const canvaFeatures: Feature[] = [
  {
    iconName: "Paintbrush",
    title: "Premium Tools",
    description: "Access to all premium design tools of Canva Pro"
  },
  {
    iconName: "Layout",
    title: "Exclusive Templates",
    description: "Thousands of exclusive professional templates"
  },
  {
    iconName: "Image",
    title: "Image Library",
    description: "Over 100 million images, videos, and graphic elements"
  }
];